<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="deleteProducto"
    >
      <header class="m-the-modal-header">
        <h5>ELIMINAR PRODUCTO</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section
        v-if="showLoadingState"
        key="loadingState"
        class="m-the-modal-section"
      >
        <AtomLoadingSecondary/>
      </section>
      <section
        v-else
        key="modalSection"
        class="m-the-modal-section"
      >
        <p>
          Se eliminará el producto
          <b>{{ element.nombre }}</b>
          y todas sus características de forma definitiva.
        </p>
        <small class="text-color-danger">
            Esta acción no podrá ser revertida.
        </small>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="'CANCELAR'"/>
        <AtomButtonPrimary
          v-if="Object.values(element).length"
          :button-primary="buttonPrimary"
        />
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingProductsModalDelete',

  data () {
    return {
      buttonPrimary: {
        action: 'ELIMINAR',
        class: 'a-button-danger-primary',
        sending: false,
        type: 'submit'
      },

      element: {},
      showLoadingState: true
    }
  },

  created () {
    this.element = this.$modal.element
    this.showLoadingState = false
  },

  methods: {
    deleteProducto () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.delete('producto', 'deleteProducto', {}, [this.element])
          .then(response => {
            this.$modal.updateData('deleteElement')
            this.$modal.closeModal()
            this.$alerts.pushAlertNotTranslated('El producto fue eliminado exitosamente.')
            if (this.$route.name !== 'edition') {
              this.$router.push(`/productos-de-vidroop/listado`)
            }
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlertNotTranslated('Un error ha ocurrido. Vuelve a intentarlo en un momento.', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
